module.exports = __webpack_public_path__ + "img/informationSmall.72508b18.png";